<script type="text/ecmascript-6">
    export default {
        props: {
            response: Object,
            selectModelsUrl: String,
        },

        data() {
            return {
                modelFilter: null,
                selectedColumn: 'A',
                headerColumn: true,
                reports: null,
                redirectUrl: null,
            }
        },

        methods: {
            selectModels() {
                let filepath = this.response.filepath;

                this.$parent.uploadFilterResponse = {};

                axios.post(this.selectModelsUrl, {
                    'filepath': filepath,
                    'modelFilter': this.modelFilter,
                    'selectedColumn': this.selectedColumn,
                    'headerColumn': this.headerColumn,
                }).then(response => {
                    if (response.data.reports) {
                        this.reports = response.data.reports;

                        if (response.data.url) {
                            this.redirectUrl = response.data.url;
                        }
                    }
                }).catch(error => {
                    toastr.error(error.response.data.message, 'Could not select models', {timeOut: 5000});
                });
            },
            redirect() {
                if (this.redirectUrl) {
                    window.location.href = this.redirectUrl;
                }
            }
        },

        computed: {
            groupedOptions() {
                return _.groupBy(this.response.selectOptions, 'alias');
            },
            loading() {
                return _.isEmpty(this.response);
            },
            allowCheck() {
                return this.modelFilter !== null;
            },
        },

        watch: {
            response() {
                if (this.response.selectOptions && this.response.selectOptions.length === 1) {
                    this.modelFilter = _.first(this.response.selectOptions).uploadFilter;
                }
            }
        },
    }
</script>
<style>
    .filterColumns td {
        cursor: pointer;
        padding: 10px 5px;
        border-right: 1px solid #e7eaec;
    }
</style>
<template>
    <portal to="modals">
        <Lightbox
                id="uploadFilterModal"
                :headline="__('scoop-os.uploadFilter.headline')"
                :large="true"
        >
            <span slot="open-template"></span>
            <div slot="body">
                <div v-if="!loading && response.exception" class="text-center">
                    <i class="fa fa-2x fa-times-circle p-h-sm text-danger"></i>
                    <p class="lead">{{ __('scoop-os.uploadFilter.error_headline') }}</p>
                    <code>{{ response.message }}</code>
                </div>
                <div v-else-if="!loading && !reports">
                    <div class="form-group">
                        <p>
                            <span class="badge">1</span>
                            <label>{{ __('scoop-os.uploadFilter.select_label') }}</label>
                        </p>
                        <select class="form-control" v-model="modelFilter">
                            <option :value="null" disabled v-show="!modelFilter">
                                {{ __('scoop-os.uploadFilter.select_default') }}
                            </option>
                            <optgroup :label="alias" v-for="(options, alias) in groupedOptions">
                                <option :value="option.uploadFilter" v-for="option in options">
                                    {{ option.displayName }}
                                </option>
                            </optgroup>
                        </select>
                    </div>
                    <hr>
                    <p>
                        <span class="badge">2</span>
                        <label>{{ __('scoop-os.uploadFilter.table_label') }}</label>
                    </p>
                    <div style="overflow-y: hidden; overflow-x: scroll;">
                        <table class="table white-bg border-top-bottom border-left-right filterColumns"
                               v-if="response.fileRows">
                            <tr class="text-center">
                                <td class="border-bottom"
                                    v-for="(column, columnIndex) in response.fileRows[2]"
                                    @click="selectedColumn = columnIndex"
                                >
                                    <input type="radio" :value="columnIndex" v-model="selectedColumn">
                                </td>
                            </tr>
                            <tr v-for="(row, rowIndex) in response.fileRows">
                                <td :class="selectedColumn === columnIndex ? 'bg-primary' : ''"
                                    v-for="(column, columnIndex) in row"
                                    @click="selectedColumn = columnIndex"
                                >
                                    <strong v-if="rowIndex == 1 && headerColumn">{{ column }}</strong>
                                    <span v-else>{{ column }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td :class="selectedColumn === columnIndex ? 'bg-primary' : ''"
                                    v-for="(column, columnIndex) in response.fileRows[2]"
                                    @click="selectedColumn = columnIndex"
                                >
                                    <small>...</small>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="headerColumn">
                            <span>{{ __('scoop-os.uploadFilter.header_checkbox_label') }}</span>
                        </label>
                    </div>
                </div>
                <div v-else-if="reports">
                    <div class="row">
                        <div class="col-lg-12" v-if="report.length" v-for="(report, displayName) in reports">
                            <component :is="displayName" :items="report" :display-name="displayName"></component>
                        </div>
                    </div>
                </div>
                <div v-else class="text-center">
                    <p class="lead">{{ __('scoop-os.uploadFilter.loading_label') }}</p>
                    <i class="fa fa-spin fa-spinner fa-2x"></i>
                </div>
            </div>
            <div v-cloak slot="footer">
                <div v-if="allowCheck && !reports">
                    <button type="button" class="btn btn-primary" @click="selectModels" v-show="!loading">
                        <span>{{ __('scoop-os.uploadFilter.button_label') }}</span>
                        <i class="fa fa-hand-pointer-o m-l-xs" aria-hidden="true"></i>
                    </button>
                </div>
                <div v-else-if="!allowCheck || (allowCheck && reports)">
                    <button type="button" class="btn btn-white" data-dismiss="modal" @click="redirect">Close</button>
                </div>
            </div>
        </Lightbox>
    </portal>
</template>